<template>
  <ui-route-aware-modal-container
    :id="HIRE_CONTRACT_TEMPLATE_COMPANY_CREATE_MODAL_ID"
    :size="UI.SIZE.SMALL"
    :fallback-route="parentRoute"
    focus="input[name='title']"
    no-header
    no-footer
  >
    <template #default="{ hideModalAndGoToRoute }">
      <ui-cloak
        :is-visible="fetchState.status.value === 'success'"
      >
        <template #default>
            <create-form
              v-bind="{
                submitCallback: (data) => createCallback(data, hideModalAndGoToRoute),
                typeProfessionList,
                isPending
              }"
            />
        </template>
      </ui-cloak>
    </template>
  </ui-route-aware-modal-container>
</template>

<script lang="ts">
import CreateForm from '~/components/hamac/contract-template/create/Organism.vue'
import Console from '~/utils/lib/core/console'
import { join, tapCatch, toString } from '~/utils/lib/core/prelude'
import { getDetailsRoute, getListRoute } from '~/stores/hamac/contract-template/company/index'
import { MENU_ITEM, NAVIGATION_SCOPE } from '~/utils/lib/layout/types'
import { useLegacyPageFetch } from '~/composables/core/hook'
import { useToastBuilder } from '~/composables/layout/toast'
import { useCompanyRequiredNavigationContext } from '~/composables/layout/navigation'
import { useStore_hamac_contractTemplate_company_details } from '~/stores/hamac/contract-template/company/details'
import { useStore_hamac_profession_typeProfession } from '~/stores/hamac/profession/type-profession'
import type { TypeProfession } from '~/stores/hamac/profession'

const console = new Console('component:company-contract-create')

const HIRE_CONTRACT_TEMPLATE_COMPANY_CREATE_MODAL_ID = `hire-contract-template-company-create-modal-id`

export default defineNuxtComponent({
  components: { CreateForm },
  setup() {
    definePageMeta({
      navigationScope: NAVIGATION_SCOPE.COMPANY_REQUIRED,
      menuItem: MENU_ITEM.EMBAUCHE,
    })
    const navigationContext = useCompanyRequiredNavigationContext()

    useHead({
      title: join(' ', [
        `Modèle de contrat → création`,
        `— ${navigationContext.fromCompanyLevel().company.raison_sociale}`
      ]),
    })

    const {
      fetchState,
      fetchWrapper,
    } = useLegacyPageFetch()

    const ToastBuilder = useToastBuilder()

    const store_contractTemplate_company_details = useStore_hamac_contractTemplate_company_details()
    const store_typeProfession = useStore_hamac_profession_typeProfession()

    return {
      ...navigationContext,
      fetchState,
      fetchWrapper,
      ToastBuilder,
      store_contractTemplate_company_details,
      store_typeProfession,
    }
  },
  data() {
    const {
      structure: { id },
      company: { code_societe }
      // @ts-expect-error: "data" hook not injecting "setup" dependencies
    } = this.fromCompanyLevel()

    const parentRoute = getListRoute(id, code_societe)

    return {
      HIRE_CONTRACT_TEMPLATE_COMPANY_CREATE_MODAL_ID,
      parentRoute,
      typeProfessionList: [] as TypeProfession[],
      isPending: false
    }
  },
  created() {
    this.fetchWrapper(
      () => this.fetch()
    )
  },
  methods: {
    createCallback(data, hideModalAndGoToRoute) {
      const opts = {
        data,
        uuidData: this.fromCompanyLevel().structure.uuidData,
        code_societe: this.fromCompanyLevel().company.code_societe,
      }

      this.isPending = true

      return this.store_contractTemplate_company_details.create(opts)
        .then(({ id }) => {
          const {
            structure: { id: structure_id },
            company: { code_societe }
          } = this.fromCompanyLevel()
          const url = getDetailsRoute(structure_id, code_societe, id)

          hideModalAndGoToRoute(url, () => {
            this.ToastBuilder
              .success()
              .class('create-model-toast')
              .title(`Nouveau modèle de contrat créé`)
              .show()
          })
        })
        .catch(err => {
          this.isPending = false

          console.warn('createCallback', err)
          this.ToastBuilder
            .error(toString(err))
            .class('create-model-toast')
            .title(`Nouveau modèle de contrat`)
            .show()
        })
    },
    fetch() {
      const options = {
        uuidData: this.fromCompanyLevel().structure.uuidData,
      }

      return this.store_typeProfession.read_(options)
        .then(results => this.typeProfessionList = results)
        .catch(tapCatch(err => {
          console.warn('fetch', err)
          this.ToastBuilder
            .error(toString(err))
            .title(`Création d'un modèle de courrier`)
            .show()
        }))
    }
  }
})
</script>
